import React from 'react'
import useStyles from './styles'

interface CoverImageProps {
    imgSrc: string
}

const CoverImage: React.FC<CoverImageProps> = ({ imgSrc }) => {
    const classes = useStyles()

    return <div className={classes.coverImg} style={{ backgroundImage: `url(${imgSrc})` }} />
}

export default React.memo(CoverImage)
